import { render, staticRenderFns } from "./OnlCgreportHeadList.vue?vue&type=template&id=0c561f5a&scoped=true&"
import script from "./OnlCgreportHeadList.vue?vue&type=script&lang=js&"
export * from "./OnlCgreportHeadList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgreportHeadList.vue?vue&type=style&index=0&id=0c561f5a&scoped=true&lang=css&"
import style1 from "./OnlCgreportHeadList.vue?vue&type=style&index=1&id=0c561f5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c561f5a",
  null
  
)

export default component.exports